import { gql } from '@apollo/client'

export const REGISTER_PGA_HOPE_GROUP_EVENT = gql`
  mutation RegisterPGAHopeGroupEvent(
    $id: ID!
    $params: PGAHopeRegisterGroupEventInput!
  ) {
    registerPgaHopeGroupEvent(id: $id, params: $params) {
      success
      message
    }
  }
`
